import { ReactNode } from 'react'
import { useSelector } from 'react-redux'
import { getProfileState } from '@/profile/stores/store'

interface MenuProps {
  name: string
  link: string
  service?: string
  group?: string
  icon: string
  suffix?: string | ReactNode
  children?: MenuProps[]
  roles?: String[]
  code: string
}

const PORTAL_PREFIX = '/stream'

export const menu: MenuProps[] = [
  {
    icon: 'teddy_regular',
    service: 'stream',
    group: 'campaign',
    name: 'title',
    link: `${PORTAL_PREFIX}/campaign`,
    code: 'CAMPAIGN_MANAGEMENT'
  },
  {
    icon: 'apps_list_regular',
    service: 'stream',
    group: 'scenario',
    name: 'title',
    link: `${PORTAL_PREFIX}/scenario`,
    code: 'SCENARIO_MANAGEMENT'
  },
  {
    icon: 'meet_now_regular',
    group: 'contact',
    service: 'stream',
    name: 'title',
    link: `${PORTAL_PREFIX}/contacts`,
    code: 'CONTACT_MANAGEMENT'
  },
  {
    icon: 'settings_regular',
    group: 'report',
    service: 'stream',
    name: 'title',
    link: `${PORTAL_PREFIX}/report`,
    code: 'REPORT_MANAGEMENT'
  },
  {
    icon: 'plug_disconnected_regular',
    group: 'provider',
    service: 'stream',
    name: 'title',
    link: `${PORTAL_PREFIX}/provider`,
    code: 'PROVIDER_MANAGEMENT'
  },
]

export const getMenu = () => {
  // const profile = useSelector(getProfileState)
  // const codeAccess = new Set<string>()
  // console.log(profile);
  // profile?.roles?.forEach((role) => role.resources?.forEach((resource) => codeAccess.add(resource.code || '')))
  // const filterMenu = menu.filter((item) => codeAccess.has(item.code))
  return menu
}
